import { useState, useMemo } from "react"
import { KpiCards } from "./KpiCards"
import { ChartsGrid } from "./ChartsGrid"
import { Breadcrumbs } from "./Breadcrumbs"
import { DashboardFilters } from "./DashboardFilters"
import { WeightedProgressChart } from "./Chart/WeightedProgressChart"
import { Button } from "antd"
import { ArrowLeftOutlined } from "@ant-design/icons"

export function DashboardView({
  data,
  weightedProgress,
  selectedProject,
  selectedPhase,
  selectedTask,
  drillDownLevel,
  selectedProjectId,
  selectedActivityId,
  onProjectSelect,
  onPhaseSelect,
  onTaskSelect,
  onProjectClick,
  onActivityClick,
  onBack,
}) {
  const [filters, setFilters] = useState({
    proyecto: "",
    fase: "",
    estado: "",
  })

  const filteredWeightedProgress = useMemo(() => {
    let progress = weightedProgress || []

    // Filtrar por proyecto
    if (filters.proyecto)
      progress = progress.filter((p) => p.codigo === filters.proyecto)

    // Filtrar por fase
    if (filters.fase)
      progress = progress
        .map((p) => ({
          ...p,
          actividades: p.actividades.filter((a) => a.fase === filters.fase),
        }))
        .filter((p) => p.actividades.length > 0)

    if (filters.estado && filters.estado !== "all") {
      progress = progress
        .map((p) => {
          const actividadesFiltradas = p.actividades
            ?.map((a) => ({
              ...a,
              tareas: a.tareas.filter((t) => t.estado === filters.estado),
            }))
            .filter((a) => a.tareas.length > 0)

          return { ...p, actividades: actividadesFiltradas }
        })
        .filter((p) => p.actividades && p.actividades.length > 0)
    }

    return progress
  }, [weightedProgress, filters.proyecto, filters.fase, filters.estado])

  const filteredData = useMemo(() => {
    if (!data) return { proyectos: [], todasLasTareas: [] }

    let proyectosFiltrados = data.proyectos || []
    let tareasFiltradas = data.todasLasTareas || []

    if (filters.proyecto) {
      proyectosFiltrados = proyectosFiltrados.filter(
        (p) => p.codigo === filters.proyecto
      )
      tareasFiltradas = tareasFiltradas.filter(
        (t) => t.proyectoCodigo === filters.proyecto
      )
    }

    if (filters.fase) {
      proyectosFiltrados = proyectosFiltrados.map((p) => ({
        ...p,
        fases: p.fases.filter((f) => f.nombre === filters.fase),
      }))
      tareasFiltradas = tareasFiltradas.filter(
        (t) => t.fase === filters.fase
      )
    }

    if (filters.estado && filters.estado !== "all") {
      tareasFiltradas = tareasFiltradas.filter(
        (t) => t.estado === filters.estado
      )
    }

    return {
      proyectos: proyectosFiltrados,
      todasLasTareas: tareasFiltradas,
    }
  }, [data, filters])

  const handleBreadcrumbClick = (level) => {
    if (level === "root") {
      onProjectSelect(null)
      onPhaseSelect(null)
      onTaskSelect(null)
      onBack()
      onBack()
    } else if (level === "project") {
      onPhaseSelect(null)
      onTaskSelect(null)
      if (drillDownLevel === "indicator") onBack()
    } else if (level === "phase") {
      onTaskSelect(null)
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <Breadcrumbs
        selectedProject={selectedProject}
        selectedPhase={selectedPhase}
        selectedTask={selectedTask}
        onNavigate={handleBreadcrumbClick}
      />

      <DashboardFilters
        filters={filters}
        onFiltersChange={setFilters}
        data={data}
      />

      <KpiCards data={filteredData} filters={filters} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        {drillDownLevel !== "project" && (
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={onBack}
            style={{
              borderColor: "#317EDA",
              color: "#317EDA",
              display: "flex",
              alignItems: "center",
            }}
          >
            Volver
          </Button>
        )}
      </div>

      <WeightedProgressChart
        projects={filteredWeightedProgress}
        drillDownLevel={drillDownLevel}
        selectedProjectId={selectedProjectId}
        selectedActivityId={selectedActivityId}
        onProjectClick={onProjectClick}
        onActivityClick={onActivityClick}
        onBack={onBack}
      />

      <ChartsGrid
        data={filteredData}
        filters={filters}
        selectedProject={selectedProject}
        selectedPhase={selectedPhase}
        onProjectSelect={onProjectSelect}
        onPhaseSelect={onPhaseSelect}
      />
    </div>
  )
}
